import { useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { MessageSquarePlus } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { GradButton } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

const TURLER = [["not", "Not"], ["hata", "Hata"], ["soru", "Soru"], ["istek", "İstek"]];

export const GeriBildirim = () => {
  const loc = useLocation();
  const [acik, setAcik] = useState(false);
  const [tur, setTur] = useState("not");
  const [mesaj, setMesaj] = useState("");
  const [busy, setBusy] = useState(false);
  const gonder = async () => {
    setBusy(true);
    try {
      await api.post("/geri-bildirim", { tur, mesaj, sayfa: loc.pathname, sayfa_adi: document.querySelector("h1")?.textContent || "" });
      toast.success("Kaydedildi, teşekkürler");
      setMesaj(""); setAcik(false);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <>
      <button onClick={() => setAcik(true)} data-testid="gb-ac" title="Not / hata bildir"
        className="fixed bottom-5 right-5 z-20 w-12 h-12 rounded-full grad-bg glow flex items-center justify-center text-white hover:scale-105 transition-transform"><MessageSquarePlus className="w-5 h-5" /></button>
      {acik && (
        <Dialog open onOpenChange={(o) => !o && setAcik(false)}>
          <DialogContent className="glass max-w-md" data-testid="gb-dialog">
            <DialogHeader><DialogTitle className="font-head">Not / hata bildir</DialogTitle></DialogHeader>
            <div className="text-xs text-muted-foreground">Ekran: <span className="font-mono">{loc.pathname}</span></div>
            <div className="flex gap-2">{TURLER.map(([k, l]) => (
              <button key={k} data-testid={`gb-tur-${k}`} onClick={() => setTur(k)} className={`px-3 py-1.5 rounded-full text-xs border ${tur === k ? "border-[var(--g1)] bg-white/10 text-white" : "border-white/10 text-muted-foreground"}`}>{l}</button>
            ))}</div>
            <Textarea data-testid="gb-mesaj" rows={5} className="bg-white/5" placeholder="Ne fark ettiniz? Ne olmasını beklerdiniz?" value={mesaj} onChange={(e) => setMesaj(e.target.value)} />
            <div className="flex justify-end gap-2"><button onClick={() => setAcik(false)} className="px-5 py-2 rounded-full border border-white/10 text-sm" data-testid="gb-vazgec">Vazgeç</button>
              <GradButton onClick={gonder} disabled={busy || mesaj.trim().length < 3} data-testid="gb-gonder">Gönder</GradButton></div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
